// Re-export the real useCaseStudies hook from useCaseStudy.ts
export { useCaseStudies } from './useCaseStudy';
